import { render, staticRenderFns } from "./JBreadcrumbs.vue?vue&type=template&id=4390f46a&scoped=true&"
import script from "./JBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./JBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./JBreadcrumbs.vue?vue&type=style&index=0&id=4390f46a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4390f46a",
  null
  
)

export default component.exports